import { useState } from 'react'

import { Box, Section } from '@factorialco/deprecated-design-system'
import { BreakConfigurationFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { useGetBreakConfigurations } from 'modules/time_categories_settings/hooks/breakConfigurations/useGetBreakConfigurations'
import CreateCustomBreakForm from 'modules/time_categories_settings/lib/forms/CreateCustomBreakForm'

import ArchivedBreaks from './ArchivedBreaks'
import BreakModal from './BreakModal'
import BreakCard from './Card'
import EmptyCard from './Card/Empty'

interface Props {
  breakConfigurations: BreakConfigurationFragment[]
}

const BreakConfigurations = ({ breakConfigurations }: Props) => {
  const [modalOpen, setModalOpen] = useState(false)
  const { archivedBreakConfigurations, loading } = useGetBreakConfigurations({})
  const form = CreateCustomBreakForm({
    setModalOpen,
  })

  const action = {
    label: i18n.t('break_types.actions.add'),
    onClick: () => setModalOpen(true),
  }

  return (
    <Section
      illustration="coffee"
      title={i18n.t('break_types.title')}
      description={i18n.t('break_types.description')}
      action={action}
    >
      <Box paddingY="s40">
        {!breakConfigurations.length && !archivedBreakConfigurations.length ? (
          <EmptyCard />
        ) : (
          <>
            <Box width="full" paddingY="s8" alignItems="center" gap="s8">
              {breakConfigurations.map((breakConfiguration) => (
                <BreakCard key={breakConfiguration.id} breakConfiguration={breakConfiguration} />
              ))}
            </Box>
            <ArchivedBreaks
              archivedBreakConfigurations={archivedBreakConfigurations}
              loading={loading}
            />
          </>
        )}
      </Box>
      {modalOpen && <BreakModal setModalOpen={setModalOpen} form={form} />}
    </Section>
  )
}

export default BreakConfigurations
